import { lazy } from 'react';

const EventParticipantModal = lazy(() => import('./EventParticipantModal'));
const EventActionModal = lazy(() => import('./EventActionModal'));
const CreateEventSlots = lazy(
  () => import('./EventSlotModals/CreateEventSlots'),
);
const EditEventSlots = lazy(() => import('./EventSlotModals/EditEventSlots'));
const InviteExternalOrganizationsModal = lazy(
  () => import('./InviteExternalOrganizationsModalV2'),
);
const CreateBlockedDatesModal = lazy(() => import('./CreateBlockedDateModal'));
const AddConfirmedOrganizationModal = lazy(
  () => import('./AddConfirmedOrganizationModal'),
);
const SubscribeCalendarModal = lazy(() => import('./SubscribeCalendarModal'));
const UserListDrawer = lazy(() => import('./UserListDrawer'));
const DeleteEventModal = lazy(() => import('./DeleteEventModal'));
const RemovedOrgsModal = lazy(() => import('./RemovedOrgsModal'));
const ShareEventModal = lazy(() => import('./ShareEventModal'));
const ThankYouEmailModal = lazy(() => import('./ThankYouEmailModal'));
const AddInstructionsModal = lazy(() => import('./AddInstructionsModal'));
const AddConfirmationEmailModal = lazy(
  () => import('./AddConfirmationEmailModal'),
);
const UploadEventFlyersModal = lazy(() => import('./UploadEventFlyersModal'));
const CopyEventWarningModal = lazy(() => import('./CopyEventWarningModal'));

const K12AdminEventCalendarSubscribeModal = lazy(
  () => import('./K12AdminEventCalendarSubscribeModal'),
);

const RemoveUnconfirmedEvents = lazy(() => import('./RemoveUnconfirmedEvents'));
const BulkRegistrationConfirmationModal = lazy(
  () => import('./BulkRegistrationConfirmationModal'),
);
const StaffEventListDrawer = lazy(() => import('./StaffEventListDrawer'));

export default {
  EVENT_PARTICIPANT_MODAL: EventParticipantModal,
  'EVENT_PARTICIPANT_MODAL/ACTION': EventActionModal,
  INVITE_EXTERNAL_ORGS: InviteExternalOrganizationsModal,
  CREATE_BLOCKED_DATE_MODAL: CreateBlockedDatesModal,
  ADD_CONFIRMED_ORGANIZATION_MODAL: AddConfirmedOrganizationModal,
  SUBSCRIBE_CALENDAR_MODAL: SubscribeCalendarModal,
  K12_ADMIN_EVENT_CALENDAR_SUBSCRIBE_MODAL: K12AdminEventCalendarSubscribeModal,
  USER_LIST_DRAWER: UserListDrawer,
  DELETE_EVENT_MODAL: DeleteEventModal,
  REMOVED_ORGS_MODAL: RemovedOrgsModal,
  SHARE_EVENT_MODAL: ShareEventModal,
  THANK_YOU_EMAIL_MODAL: ThankYouEmailModal,
  ADD_INSTRUCTIONS_MODAL: AddInstructionsModal,
  ADD_CONFIRMATION_EMAIL_MODAL: AddConfirmationEmailModal,
  UPLOAD_EVENT_FLYERS_MODAL: UploadEventFlyersModal,
  COPY_EVENT_WARNING_MODAL: CopyEventWarningModal,
  CREATE_EVENT_SLOTS_MODAL: CreateEventSlots,
  EDIT_EVENT_SLOTS_MODAL: EditEventSlots,
  REMOVE_UNCONFIRMED_EVENTS_MODAL: RemoveUnconfirmedEvents,
  BULK_REGISTRATION_CONFIRMATION_MODAL: BulkRegistrationConfirmationModal,
  STAFF_EVENT_LIST_DRAWER: StaffEventListDrawer,
};
